// Customizable Area Start
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { CometChatCalls } from "@cometchat/calls-sdk-javascript";

let cometInitPromise: Promise<void> | null = null;

export const initCometChat = () => {
  if (!cometInitPromise) {
    const appID = process.env.REACT_APP_COMET_CHAT_APP_ID!;
    const region = process.env.REACT_APP_COMET_CHAT_REGION!;

    const appSetting = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(region)
      .build();

    const callAppSetting = new CometChatCalls.CallAppSettingsBuilder()
      .setAppId(appID)
      .setRegion(region)
      .build();

    cometInitPromise = CometChat.init(appID, appSetting)
      .then(async () => {
        await CometChatCalls.init(callAppSetting);
      })
      .catch((error) => {
        console.error("CometChat initialization failed:", error);
        cometInitPromise = null;
        throw error;
      });
  }

  return cometInitPromise;
};

export const getTotalUnreadCount = async (
  selectedChatUID: string
): Promise<number> => {
  try {
    const user = await CometChat.getLoggedinUser();
    if (!user) return 0;

    const unreadMessages = await CometChat.getUnreadMessageCountForAllUsers(
      true
    );
    const totalCount = Object.keys(unreadMessages)
      .filter((uid) => uid !== selectedChatUID)
      .reduce(
        (sum, uid) => sum + (unreadMessages as Record<string, number>)[uid],
        0
      );

    return totalCount;
  } catch (err) {
    return 0;
  }
};

export const getLoggedInUserAuthToken = async () => {
  try {
    const loggedInUser = await CometChat.getLoggedinUser();
    if (loggedInUser) {
      return loggedInUser.getAuthToken();
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const generateCallToken = async (
  sessionID: string,
  authToken: string
) => {
  try {
    const res = await CometChatCalls.generateToken(sessionID, authToken);
    return res.token;
  } catch (error) {
    return null;
  }
};
// Customizable Area End
